import { render, staticRenderFns } from "./servicerFirstEidt.vue?vue&type=template&id=4541bae1&scoped=true"
import script from "./servicerFirstEidt.vue?vue&type=script&lang=js"
export * from "./servicerFirstEidt.vue?vue&type=script&lang=js"
import style0 from "./servicerFirstEidt.vue?vue&type=style&index=0&id=4541bae1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541bae1",
  null
  
)

export default component.exports